var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"felir","sortable":"custom","label":"FELIR","show-overflow-tooltip":"","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(scope.row.felir)+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }